export default __webpack_public_path__ + "static/media/1220.63c7fee0.png";